import { render } from "./KeyContainer.vue?vue&type=template&id=8b1efd2e"
import script from "./KeyContainer.vue?vue&type=script&lang=js"
export * from "./KeyContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__